import { render, staticRenderFns } from "./AccidentIntakeAboutYouForm.vue?vue&type=template&id=4f6599b6&scoped=true"
import script from "./AccidentIntakeAboutYouForm.vue?vue&type=script&lang=js"
export * from "./AccidentIntakeAboutYouForm.vue?vue&type=script&lang=js"
import style0 from "./AccidentIntakeAboutYouForm.vue?vue&type=style&index=0&id=4f6599b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6599b6",
  null
  
)

export default component.exports